import React, { useState } from 'react';
import { Typography, Card, Grid, ToggleButton, Box, Stack } from "@mui/material";
import ConGuestTableIndex from "./contractor_guest"
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import StyledToggleButtonGroup from '../../../overrides/toggleButton';
import EmployeeTableIndex from './employee';
import TotQtyTableIndex from './TotalQuantity';

const MealCount = ({ dayTabVal }) => {

    const { SwipeReducers: { SwipeList } } = useSelector((state) => state)

    const userVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 1 : 8]) || []
    const userSessionVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 2 : 9]) || []
    const contractorVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 3 : 10]) || []
    const contractorSessionVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 4 : 11]) || []
    const guestVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 5 : 12]) || []
    const guesSessiontVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 6 : 13]) || []
    const totalVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 0 : 7]) || []
    const sessionTotalVal = (SwipeList.length && SwipeList[dayTabVal === 1 ? 7 : 9]) || []

    const [alignment, setAlignment] = useState(1);

    const handleAlignment = (event, newAlignment) => {
        if (!newAlignment) {
            return
        }
        setAlignment(newAlignment);
    };

    const cardVal = alignment === 1 ? userVal : (alignment === 2 ? contractorVal : guestVal)
    const tableVal = alignment === 1 ? userSessionVal : (alignment === 2 ? contractorSessionVal : guesSessiontVal)

    return (
        <>
            <Card sx={{ border: (theme) => `1px solid ${theme.palette.grey[200]}`, boxShadow: (theme) => `0px 15px 23px ${theme.palette.grey[200]}`, margin: '30px' }}>
                <Box margin='30px 0 0 30px'>
                    <Typography variant='t20_600'>{dayTabVal === 1 ? `Today's Order` : `Next Day's Order`}</Typography>
                    <Typography variant='t20_600' color='primary' fontFamily='inter' pl='10px'>
                        {totalVal.length && totalVal[0].TotalQuantity}
                    </Typography>
                </Box>

                <Grid container spacing={3} sx={{ marginBottom: '35px', marginTop: '10px' }} >
                    <Grid item xs={12} lg={12} sx={{ display: 'flex', justifyContent: 'left' }}>
                        <Box sx={{ width: '800px', marginLeft: '35px', marginRight: '30px' }} >
                            <TotQtyTableIndex tblData={sessionTotalVal} />
                        </Box>
                    </Grid>
                </Grid>

                <Stack direction={{ sm: 'row', xs: 'column' }}>
                    <div style={{ margin: '30px', marginBottom: 0 }}>
                        <Paper
                            elevation={0}
                            sx={{
                                display: 'flex',
                                border: (theme) => `1px solid ${theme.palette.divider}`,
                                flexWrap: 'wrap',
                                width: 'max-content'
                            }}
                        >
                            <StyledToggleButtonGroup
                                size="medium"
                                value={alignment}
                                exclusive
                                onChange={handleAlignment}
                                aria-label="text alignment"
                            >
                                <ToggleButton value={1} aria-label="left aligned" sx={{ width: '100px' }}>
                                    <Typography variant='t15_600'>Employee</Typography>
                                </ToggleButton>
                                <ToggleButton value={2} aria-label="centered">
                                    <Typography variant='t15_600'>Contractor</Typography>
                                </ToggleButton>
                                <ToggleButton value={3} aria-label="centered" sx={{ width: '100px' }}>
                                    <Typography variant='t15_600'>Guest</Typography>
                                </ToggleButton>

                            </StyledToggleButtonGroup>
                        </Paper>
                    </div>
                </Stack>

                {alignment !== 1 &&
                    <Grid container spacing={3} sx={{ marginBottom: '35px', marginTop: '10px' }} >
                        {cardVal.map((m, i) => {
                            const tblData = tableVal?.filter(d => d.cMealName === m.cMealName)
                            return <Grid item key={m.cMealName} xs={12} lg={6} sx={{ display: 'flex', justifyContent: 'left' }}>
                                <Box sx={{ width: '800px', marginLeft: '35px', marginRight: '30px', mt:'auto' }} >
                                    <ConGuestTableIndex cardData={m} tblData={tblData} userType={alignment} />
                                </Box>
                            </Grid>
                        })}
                    </Grid>
                }

                {alignment === 1 &&
                    <Grid container spacing={3} sx={{ marginBottom: '35px', marginTop: '10px' }} >
                        {cardVal.map((m, i) => {
                            const tblData = tableVal?.filter(d => d.cMealName === m.cMealName)
                            return <Grid item key={m.cMealName} xs={12} lg={6} sx={{ display: 'flex', justifyContent: 'left' }}>
                                <Box sx={{ width: '800px', marginLeft: '35px', marginRight: '30px', mt:'auto' }} >
                                    <EmployeeTableIndex cardData={m} tblData={tblData} />
                                </Box>
                            </Grid>
                        })}
                    </Grid>
                }
            </Card>
        </>

    )
}

export default MealCount;